import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"
import { Observable, map, takeWhile, timer } from "rxjs"

import { environment } from "src/environments/environment"
import { walmartDomain } from "../constants/forms.constants"

export const esUsuarioWalmart = ( username: string  ) : boolean => {
    const listaDominios = [ "walmart", "wal-mart" ]
    return listaDominios.some( d => username.toLowerCase().includes(d) )
}

export const countdownTimer = (fechaFin:Date) : Observable<number> => {
    const ahora = new Date().getTime()
    const termino = fechaFin.getTime()

    const segundos = (termino - ahora) / 1000
    return timer(0, 1000).pipe(
      map(n => (segundos - n) * 1000),
      takeWhile(n => n >= 0)
    )
}

export const showTkInput = ( event: MouseEvent ) : void => {
	const input = event.target as HTMLElement
	if(input.innerText =='visibility'){
	  input.innerText = 'visibility_off';
	  input.parentElement?.previousElementSibling?.getElementsByTagName("input")[0]?.setAttribute('type','text')
	}else if(input.innerText == 'visibility_off'){
	  input.innerText = 'visibility';
	  input.parentElement?.previousElementSibling?.getElementsByTagName("input")[0]?.setAttribute('type','password')
	}

}


export const tkValidator = ( username: string ) : ValidatorFn => {
		return ( control: AbstractControl ) : ValidationErrors | null => {
		const value = control.value;
		if( !value ) return null;
		if( !basicRules( value ) ) return { tk: true, tkBasic: true, message: "Incluir números, mayúsculas, minúsculas y caracteres especiales" };
		if( !correctSize( value ) ) return { tk: true, tkSize: true, message: "Mínimo 7 caracteres." };
		if( orderSequence( value ) ) return { tk: true, tkOrder: true, message: "No incluir caracteres ascendentes/descendentes. Ej: 12345 o abcde" };
		if( repeatSequence( value ) ) return { tk: true, tkSecuence: true, message: "No incluir secuencia repetidas. Ej: 1a2bc1a2bc" };
		if( repeatCharacters( value ) ) return { tk: true, tkRepeatChars: true, message: "No incluir caracteres repetidos. Ej: aAaa" };
		if( sequenceKeyboard( value ) ) return { tk: true, tkKeyboroard: true, message: "No incluir secuencias del teclado. Ej: qwert" };
		if( userMatchInText( username, value ) ) return { tk: true, tkUsername: true, message: "No incluir alguna secuencia del correo electrónico" };
		return null;
	}
}
export const getMessageTkValidator = ( control:AbstractControl ) : string | null => {
	return (control.errors as any)?.message
}


/**
 * Funcion que evalua el punto F1 de las politicas de contraseña
 * de walmart.
 * Básicamente es que una letra no se repita más de n veces en la
 * contraseña.
*/
// F.1
export const orderSequence = ( text:string, tolerance: number = 4 ) : boolean => {
	const validLetters = arrayRange("a".charCodeAt(0), "z".charCodeAt(0));
	const validNumber = arrayRange("0".charCodeAt(0), "9".charCodeAt(0));
	const validCharacters = [...validLetters,...validNumber];
	const lettersList = Array.from( text.toLocaleLowerCase() );
	let count = 0;
	lettersList.forEach( (letter, idx) => {
		if( idx == lettersList.length-1 ) return;
		if( count >= tolerance ) return;
		const current = letter.charCodeAt(0);
		if( validCharacters.indexOf( current ) < 0 ) {
			count = 0;
			return;
		};
		const next = lettersList[idx+1].charCodeAt(0);
		if( Math.abs( next - current ) == 1 ) {
			count++;
		}else{
			count = 0;
		}
	} )

	return count >= tolerance;
}

/**
 * Funcion que evalua el punto F2 de las politicas de contraseña
 * de walmart.
 * Básicamente que una subcadena de x caracteres no se repita dentro de la cadena
 */
// F.2
export const repeatSequence = ( text: string, tolerance: number = 4 ) :  boolean => {
	let count = 0;
	if( text.length <= tolerance ) return false;
	text = text.toLocaleLowerCase();
	while( count < text.length ) {
		const end = count + (tolerance + 1);
		const currentText = text.slice(count, end);
		const residualText = text.slice( end );
		if( currentText.length <= tolerance || residualText.length <= tolerance ) return false;
		if( residualText.indexOf( currentText ) >= 0 ) return true;
		count++;
	}
	return false;
}

/**
 * Funcion que evalua el punto F3 de las politicas de contraseña
 * de walmart.
 * Básicamente es que una letra no se repita más de n veces en la
 * contraseña.
 */
// F.3
export const repeatCharacters = ( text: string, tolerance: number = 3 ) : boolean => {
	let repeated = false;
	const lettersList = Array.from(text.toLocaleLowerCase())
	let tempList = []
	lettersList.forEach( (letter, idx) => {
		tempList = [...lettersList]
		if( !repeated ) {
			const subgroup = tempList.slice( idx, idx+(tolerance+1) );
			repeated = subgroup.length == 4 && subgroup.every( l => l == letter )
		}
	});
	return repeated
}

/**
 * Funcion que evalua el punto F4 de las politicas de contraseña
 * de walmart.
 * Básicamente es que no se pueda escribir una secuencia del teclado
 */
// F.4
export const sequenceKeyboard = ( text: string, tolerance: number = 4 ) : boolean => {
	const keyboard : any = {"1":0,"2":1,"3":2,"4":3,"5":4,"6":5,"7":6,"8":7,"9":8,"0":9,"q":11,"w":12,"e":13,"r":14,"t":15,"y":16,"u":17,"i":18,"o":19,"p":20, "a":21,"s":22,"d":23,"f":24,"g":25,"h":26,"j":27,"k":28,"l":29,"z":31,"x":32,"c":33,"v":34,"b":35,"n":36,"m":37};
	const lettersList = Array.from( text.toLocaleLowerCase() );
	if( lettersList.length < tolerance ) return false;
	let count = 0;
	lettersList.forEach( (letter, idx) => {
		if( idx == lettersList.length-1 ) return;
		if( count >= tolerance ) return;
		const current = getValue(letter, keyboard);
		if( !current ) {
			count = 0;
			return;
		}
		const next = getValue(lettersList[idx+1], keyboard);
		if( Math.abs( next - current ) == 1 ) {
			count++;
		}else{
			count = 0;
		}
	} );
	return count >= tolerance;
}

/**
 * Funcion que evalua el punto F5 y F6 de las politicas de contraseña de Walmart.
 * Básicamente valida la existencia del nombre de usuario en la contraseña.
 */
// F.5 & F.6
export const userMatchInText = ( user: string, text: string, tolerance: number = 3 ) : boolean => {
	if( !user || !text || user.length < tolerance || text.length < tolerance ) return false;
	user = user.toLocaleLowerCase();

	text = text.toLocaleLowerCase();
	if( text.indexOf( user ) >= 0 ) return true; // If username exist in text
	let count = 0;
	while( count < user.length ) {
		const end = count + (tolerance + 1);
		const currentText = user.slice(count, end);
				if( currentText.length <= tolerance ) return false;
		if( text.indexOf( currentText ) >= 0 ) return true;
		count++;
	}
	return false;
}

/**
 * Funcion que evalua el punto G de las politicas de contraseña de Walmart.
 * Básicamente la contraseña debe cumplir con almenos n reglas de las siguientes:
 * -Contener un numero
 * -Contener una mayuscula
 * -Contener una minuscula
 * -Contener un caracter especial
 * -Contener un caracter unicode
 * */
// G
export const basicRules = ( text: string, minCategories: number = 3 ) : boolean => {
	const regexNumber = /([0-9])+/;
	const regexMinus = /([a-z])+/;
	const regexMayus = /([A-Z])+/;
	const regexSpecialCharacters = /(?=.*[@$!%.*#?&])+/;
	const regexUnicode = /[€Γƒ]/;

	let count = 0;
	if(regexNumber.test(text)) count++;
	if(regexMinus.test(text)) count++;
	if(regexMayus.test(text)) count++;
	if(regexSpecialCharacters.test(text)) count++;
	if(regexUnicode.test(text)) count++;
	return count >= minCategories;
}

/**
 * Funcion que evalua el tamaño de la contraseña acorde a las politicas de walmart
 * */
export const correctSize = ( text: string, minSize: number = 7, maxSize: number = 999 ) => text.length >= minSize && text.length <= maxSize



const getValue = ( char:any, list: any[] ) =>  list[char];

const arrayRange = (start:number, stop:number, step:number = 1) =>
    Array.from(
	    { length: (stop - start) / step + 1 },
	    (value, index) => start + index * step
    );

export const emailWalMartCheck = () : ValidatorFn => {
	return (control : AbstractControl) : ValidationErrors | null => {
		const correo : string = control?.value
		if(!correo) return null
		if(correo.length < 1) return null
		if(!environment.regex.correo?.test(correo)) return {email : true}
		if(correo.toLowerCase().split("@")[1].includes("walmart") )return {noWalMart : true}
		return null
	}
}

export const currentIp = () => window.location.origin

export const walmartValidEmail = ( email:string ) => {
	return email.split("@")[1].toLowerCase().includes( walmartDomain )

}

const INVISIBLE_CHARS = /[\u200B-\u200F\u202A-\u202E\u2060\uFEFF\u00AD]/g;

export const normalizarCorreo = (valor: string): string =>
  valor.normalize('NFKC').replace(INVISIBLE_CHARS, '').trim();
